import { Skeleton } from "@mui/material";

import styles from "./DataTableSkeleton.module.css";

interface DataTableSkeletonProps {
  rowCount: number;
  columnCount: number;
  hasSelectionColumn: boolean;
}

const CELL_WIDTHS = ["70%", "55%", "85%", "45%", "65%", "60%", "50%"];

export function DataTableSkeleton({
  rowCount,
  columnCount,
  hasSelectionColumn,
}: DataTableSkeletonProps) {
  return (
    <div className={styles.skeleton} aria-busy="true" aria-label="Loading">
      <div className={styles.header} />
      <div className={styles.body}>
        {Array.from({ length: rowCount }).map((_, rowIdx) => (
          <div key={rowIdx} className={styles.row}>
            {hasSelectionColumn ? (
              <div className={styles.checkboxCell}>
                <Skeleton variant="rectangular" width={16} height={16} />
              </div>
            ) : null}
            {Array.from({ length: columnCount }).map((_, colIdx) => (
              <div key={colIdx} className={styles.cell}>
                <Skeleton
                  variant="text"
                  width={CELL_WIDTHS[colIdx % CELL_WIDTHS.length]}
                  animation="wave"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
